module.exports = __webpack_public_path__ + "3d5cfe6b91559dc466e573770043cf6f.MP3";